export class SpecificStatus {
  public id: number;
  public code?: string;
  public globalStatusId?: number;
  public description?: string;
  public displayOrder: number;
}
